export default __webpack_public_path__ + "static/media/Check_Vehicle_Info.33f3be21.svg";